<template lang="pug">
    div(v-if="taxSummaries.length && !cancelledItemContext")
        .row
            .col-xs-12
                small.dark.block.text-center.m-b-sm {{ trans('receipt.tax_summary') }}
        .row
            .col-xs-3 
                small.bold {{ trans('receipt.tax') }}
            .col-xs-3 
                small.bold {{ trans('receipt.rate') }}
            .col-xs-3 
                small.bold {{ trans('receipt.taxable_sales') }}
            .col-xs-3 
                small.bold {{ trans('receipt.tax_amount') }}
        div(v-for="taxSummary in taxSummaries")
            .row
                .col-xs-3 
                    small {{ taxSummary.shortName }}
                .col-xs-3 
                    small {{ taxSummary.rate }}%
                .col-xs-3 
                    small {{ taxSummary.taxableSales.toFixed(2) }}
                .col-xs-3 
                    small {{ taxSummary.amount.toFixed(2) }}
</template>

<script>
import { mapGetters } from 'vuex';
import formattedCurrencyMixin from '@js/mixins/formatted-currency';

export default {
    mixins: [formattedCurrencyMixin],

    computed: {
        ...mapGetters('transactionPostgres', [
            'taxSummaries',
            'cancelledItemContext',
        ]),
    },
};
</script>
